import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { LocalStorageKeys } from '../core/constants/localStorageKeys.enum';
import { filter, map, tap } from 'rxjs/operators';

export type EnvironmentSetting = {
	settingName: string;
	settingValue: string;
};

@Injectable()
export class EnvironmentSettingsService {
    private readonly environmentSubject = new BehaviorSubject<Array<EnvironmentSetting>>(null);
    public get environment$() {
		return this.environmentSubject
			.asObservable()
			.pipe(
				tap(async settings => {
					if (!settings) {
						await this.initialize();
					}
				})
			)
	}



	constructor(private httpClient: HttpClient) { }

    public currentTaxRate$: Observable<number> = this.environment$
        .pipe(
            filter(settings => !!settings),
            map(settings => {
                const taxRateSettings = settings.filter(x => x.settingName === 'TaxRate');
                if (taxRateSettings.length === 0) {
                    throw new Error('Tax rate not found in environment settings.');
                }
                return Number(taxRateSettings[0].settingValue);
            })
        );

	public async initialize(): Promise<string> {
		return new Promise<string>(async (resolve, reject) => {
			try {
				const environmentSettings = await this.getEnvironmentSettings(environment.environmentName, true).toPromise();

				if (environmentSettings) {
					localStorage.setItem(
						LocalStorageKeys.ENVIRONMENT,
						JSON.stringify(environmentSettings)
					);
                    this.environmentSubject.next(environmentSettings);
					resolve('Success');
				} else {
					reject('Error occurred while setting up application environment.');
				}
			} catch (err) {
				console.error('Error initializing env settings', err);
				reject('Error occurred while setting up application environment.');
			}
		});
	}

	public reset(): void {
		this.environmentSubject.next(null);
		localStorage.removeItem(LocalStorageKeys.ENVIRONMENT);
	}

	private getEnvironmentSettings(environmentName: string, clientSide: boolean) {
		const url = `${environment.dotNetApiUrl}/Core/EnvironmentSettings/GetByEnvironment?environment=${environmentName}&clientSide=${clientSide}`;
		return this.httpClient.get<Array<EnvironmentSetting>>(url);
	}
}



// WEBPACK FOOTER //
// ./src/app/shared-services/environment-settings.service.ts